import { useState } from "react";
import { MailWarning, Send } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("fr-CA", { timeZone: "America/Toronto", dateStyle: "medium", timeStyle: "short" }) + " HE" : "jamais");

export const RelanceInvitation = ({ compte, onDone }) => {
  const [busy, setBusy] = useState(false);
  if (!compte?.invitation_en_attente) return null;
  const relancer = async () => {
    setBusy(true);
    try { await api.post(`/demandes/prescripteurs/${compte.id}/relancer`); toast.success(`Invitation renvoyée à ${compte.email}`); onDone(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="mt-2 flex flex-wrap items-center gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800" data-testid="relance-invitation">
      <MailWarning className="h-4 w-4" />
      <span>Mot de passe pas encore choisi · dernière invitation : {fmt(compte.invitation_envoyee_le)}</span>
      <Button size="sm" variant="outline" disabled={busy} onClick={relancer} className="ml-auto h-7" data-testid="relance-invitation-button">
        <Send className="h-3 w-3 mr-1" /> Renvoyer l'invitation
      </Button>
    </div>
  );
};
